/* AGENT PROFILES */
export const GET_ANSWER_AGENT_PROFILE = "GET_ANSWER_AGENT_PROFILE"
export const GET_ANSWER_AGENT_PROFILE_SUCCESS = "GET_ANSWER_AGENT_PROFILE_SUCCESS"
export const GET_ANSWER_AGENT_PROFILE_ERROR = "GET_ANSWER_AGENT_PROFILE_ERROR"

export const QUOTE_FUNNEL_QUESTIONS = "QUOTE_FUNNEL_QUESTIONS"
export const QUOTE_FUNNEL_QUESTIONS_SUCCESS = "QUOTE_FUNNEL_QUESTIONS_SUCCESS"
export const QUOTE_FUNNEL_QUESTIONS_ERROR = "QUOTE_FUNNEL_QUESTIONS_ERROR"

export const UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS = "UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS"
export const UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_SUCCESS = "UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_SUCCESS"
export const UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_ERROR = "UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_ERROR"

export const GET_QUOTE_FUNNEL_SESSION_ID="GET_QUOTE_FUNNEL_SESSION_ID"
export const GET_QUOTE_FUNNEL_SESSION_ID_SUCCESS="GET_QUOTE_FUNNEL_SESSION_ID_SUCCESS"
export const GET_QUOTE_FUNNEL_SESSION_ID_ERROR="GET_QUOTE_FUNNEL_SESSION_ID_ERROR"

export const CREATE_QUOTE_FORM_VISIT_SUCCESS="CREATE_QUOTE_FORM_VISIT_SUCCESS"
export const CREATE_QUOTE_FORM_VISIT_ERROR="CREATE_QUOTE_FORM_VISIT_ERROR"

export const UPDATE_QUOTE_FORM_VISIT_SUCCESS = "UPDATE_QUOTE_FORM_VISIT_SUCCESS"